import React from 'react';
import {Button, ControlLabel, FormControl, FormGroup, Modal} from 'react-bootstrap';
import Table from '../../../../../../components/Table';
import './styles.css'
import _ from 'lodash';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import SelectAsync from 'react-select/lib/Async';
import {personFullName} from "../../../../../../services/Api";

class MailerTagDetailModal extends React.Component {
    static contextTypes = {api: PropTypes.object, notifier: PropTypes.object};

    constructor(props) {
        super(props);
        this.state = {
            type: 'member',
            selectedOption: null
        };
    }

    loadEmailAddressesAssigned = (tableState) => {
        this.tableState = tableState;
        if (tableState.filters.name) tableState.filters['name'] = tableState.filters.name;
        const filters = {...tableState.filters, 'mailerTags.id': this.props.mailerTag.id};
        this.context.api.emailAddresses.get(tableState.page, tableState.pageSize, undefined, filters)
            .then(assigned => this.setState({
                emailAddressesAssigned: assigned,
                noEmailAddressesAssigned: this.props.emailAddressesMeta.totalItems
            }))
    };

    loadMemberAssigned = (tableState) => {
        this.tableState = tableState;
        if (tableState.filters.name) tableState.filters['name'] = tableState.filters.name;
        const filters = {...tableState.filters, 'mailerTags.id': this.props.mailerTag.id};
        this.context.api.people.get(tableState.page, tableState.pageSize, undefined, filters)
            .then((assigned = []) => {
                this.setState({membersAssigned: assigned, noMembersAssigned: this.props.peopleMeta.totalItems})
            })
    };

    loadEmailAddresses = (name) => {
        return this.context.api.emailAddresses.get(0, 10, undefined, {name: name}, "allEmailAddresses")
            .then((allEmailAddresses = []) => allEmailAddresses.map((emailAddress) => ({
                value: emailAddress.id,
                label: emailAddress.name,
                tags: emailAddress.mailerTags
            })))
    };

    loadPeople = (name) => {
        return this.context.api.people.get(0, 10, undefined, {orSearch_fullname: name, 'membership[exists]': true})
            .then((people = []) => people.map((person) => ({
                value: person.membership.id,
                label: personFullName(person),
                tags: person.mailerTags
            })))
    };

    debouncedLoadEmailAddressesAssigned = _.debounce(this.loadEmailAddressesAssigned, 200);

    componentDidMount = () => this.context.api.clearProperty('emailAddresses');

    add = () => this.setState({'adding': true});

    hideAdding = () => this.setState({'adding': false, selectedOption: null, type: 'member'});

    onSelectChange = (e) => {
        this.setState({newContact: {id: e.value, name: e.label, tags: e.tags}, selectedOption: e})
    };

    onSelectMemberChange = (e) => {
        this.setState({newMember: {id: e.value, name: e.label, tags: e.tags}, selectedOption: e})
    };

    setType = (e) => {
        this.setState({type: e.target.value, newContact: null, newMember: null, selectedOption: null});
    };

    saveAddressAssignation = () => {
        let emailExists = false;
        for (let i = 0; i < this.state.emailAddressesAssigned.length; i++) {
            if (this.state.emailAddressesAssigned[i].id === this.state.newContact.id) emailExists = true;
        }
        if (emailExists) return this.context.notifier.error('El contacto ya está asignado a este grupo de correo');

        this.context.api.emailAddresses.edit(this.state.newContact.id, {"mailerTags": [...this.state.newContact.tags, this.props.mailerTag.id]})
            .then(() => {
                this.state.emailAddressesAssigned.push({id: this.state.newContact.id, name: this.state.newContact.name})
                let emailAddresses = this.state.noEmailAddressesAssigned + 1
                this.setState({noEmailAddressesAssigned: emailAddresses})
            })
            .then(this.setState({'adding': false, selectedOption: null, type: 'member'}))
    };

    deleteAssignedEmailAddress = (e) => {
        const id = this.state.emailAddressesAssigned[e.currentTarget.dataset.index].id;
        this.context.api.emailAddresses.getById(id)
            .then(emailAddress => {
                let contacto = emailAddress;
                for (let i = 0; i < contacto.mailerTags.length; i++) {
                    if (contacto.mailerTags[i].id === this.props.mailerTag.id) contacto.mailerTags.splice(i, 1)
                }
                this.context.api.emailAddresses.edit(id, contacto, undefined)
                    .then(() => {
                        let emailAddresses = this.state.noEmailAddressesAssigned - 1;
                        this.setState({noEmailAddressesAssigned: emailAddresses});
                    })
            })
            .then(() => {
                let {emailAddressesAssigned} = this.state;
                for (let i = 0; i < emailAddressesAssigned.length; i++) {
                    if (emailAddressesAssigned[i].id === id) {
                        emailAddressesAssigned.splice(i, 1);
                    }
                }
                this.setState({emailAddressesAssigned: emailAddressesAssigned, type: 'member'});
            })
    };

    saveMemberAssignation = () => {
        let memberExists = false;
        for (let i = 0; i < this.state.membersAssigned.length; i++) {
            if (this.state.membersAssigned[i].id === this.state.newMember.id) memberExists = true;
        }
        if (memberExists) return this.context.notifier.error('El miembro ya está asignado a este grupo de correo');
        let tagsGuardados = this.state.newMember.tags, tags = [];
        for (let i = 0; i < tagsGuardados.length; i++) {
            tags.push(tagsGuardados[i].id)
        }
        tags.push(this.props.mailerTag.id);
        this.context.api.people.edit(this.state.newMember.id, {"mailerTags": tags})
            .then(() => {
                this.state.membersAssigned.push({id: this.state.newMember.id, name: this.state.newMember.name})
                let members = this.state.noMembersAssigned + 1;
                this.setState({noMemberssAssigned: members})
            })
            .then(this.setState({'adding': false, selectedOption: null}))
    };

    deleteAssignedMember = (e) => {
        const id = this.state.membersAssigned[e.currentTarget.dataset.index].id;
        this.context.api.people.getById(id)
            .then(member => {
                let miembro = member;
                for (let i = 0; i < miembro.mailerTags.length; i++) {
                    if (miembro.mailerTags[i].id === this.props.mailerTag.id) miembro.mailerTags.splice(i, 1)
                }
                let tagsGuardados = member.mailerTags, tags = [];
                for (let i = 0; i < tagsGuardados.length; i++) {
                    tags.push(tagsGuardados[i].id)
                }
                miembro.mailerTags = tags;
                this.context.api.people.edit(id, miembro, undefined)
                    .then(() => {
                        let members = this.state.noMembersAssigned - 1;
                        this.setState({noMembersAssigned: members});
                    })
            })
            .then(() => {
                let {membersAssigned} = this.state;
                for (let i = 0; i < membersAssigned.length; i++) {
                    if (membersAssigned[i].id === id) membersAssigned.splice(i, 1);
                }
                this.setState({membersAssigned: membersAssigned});
            })
    };

    tableDefinitionMembers =
        [
            {
                name: 'Acción',
                accessor: (data, index) =>
                    <span>
                        <button className='btn btn-xs btn-danger' data-index={index}
                                onClick={this.deleteAssignedMember}><i className='ti-trash'/></button>
                    </span>
            }, {
            name: 'Nombre',
            filterable: true,
            id: 'name',
            accessor: (person) => personFullName(person),
        }
        ];

    tableDefinitionContacts =
        [
            {
                name: 'Acción',
                accessor: (data, index) =>
                    <span>
                        <button className='btn btn-xs btn-danger' data-index={index}
                                onClick={this.deleteAssignedEmailAddress}><i className='ti-trash'/></button>
                    </span>
            }, {
            name: 'Nombre',
            filterable: true,
            id: 'name',
            accessor: 'name',
        }
        ];

    render() {
        const {selectedOption} = this.state;

        return (
            <div>
                <Modal
                    show={true}
                    onHide={this.props.onHide}
                    className={'MailerTagDetailModal custom-dialog '}>
                    <Modal.Header closeButton>
                        <Modal.Title>Detalle de grupo de correo {this.props.mailerTag.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {!this.props.mailerTag.createdBySystem &&
                        <button className='btn btn-success btn-fill btn-magnify pull-right btn-add' onClick={this.add}>
                            <span className='btn-label'><i className='ti-plus'/></span>
                        </button>}
                        <div>
                            <p><b>Miembros asignados:</b></p><br/>
                            <Table
                                paginated
                                defaultPageSize={50}
                                rowIdAccessor={'id'}
                                totalItems={this.state.noMembersAssigned ? this.state.noMembersAssigned : null}
                                loadData={this.loadMemberAssigned}
                                columns={this.tableDefinitionMembers}
                                data={this.state.membersAssigned}/>
                            <br/>
                            <p><b>Contactos asignados:</b></p><br/>
                            <Table
                                paginated
                                defaultPageSize={50}
                                rowIdAccessor={'id'}
                                totalItems={this.state.noEmailAddressesAssigned ? this.state.noEmailAddressesAssigned : null}
                                loadData={this.loadEmailAddressesAssigned}
                                columns={this.tableDefinitionContacts}
                                data={this.state.emailAddressesAssigned}/>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle='danger' onClick={this.props.onHide}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>

                {this.state.adding &&
                <Modal
                    size='sm'
                    show={true}
                    className='MailerTagDetailModal'
                    onHide={this.hideAdding}>
                    <Modal.Header closeButton>
                        <Modal.Title>Añadir persona a grupo de correo {this.props.mailerTag.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormGroup>
                            <ControlLabel>Tipo de persona:</ControlLabel>
                            <FormControl componentClass="select" name='type' onChange={this.setType} required>
                                <option value='' disabled>Selecciona el tipo de persona a asignar</option>
                                <option value='member'>Miembro</option>
                                <option value='contact'>Contacto de direcciones de correo</option>
                            </FormControl>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Nombre:</ControlLabel>
                            <SelectAsync
                                value={selectedOption}
                                placeholder={this.state.type === 'member' ? 'Nombre del miembro a agregar' : 'Nombre del contacto a agregar'}
                                noOptionsMessage={() => "Sin coincidencias"}
                                loadOptions={this.state.type === 'member' ? this.loadPeople : this.loadEmailAddresses}
                                onChange={this.state.type === 'member' ? this.onSelectMemberChange : this.onSelectChange}/>
                        </FormGroup>
                        <Button bsStyle='danger'
                                onClick={this.hideAdding}>Cancelar</Button>
                        <Button bsStyle='success'
                                onClick={this.state.type === 'member' ? this.saveMemberAssignation : this.saveAddressAssignation}
                                className='pull-right'>Añadir</Button>
                    </Modal.Body>
                </Modal>}
            </div>
        );
    }
}

const mapStateToProps = ({api: {emailAddresses = [], emailAddressesMeta = {}, people = [], peopleMeta = {}},}) => ({
    emailAddresses,
    emailAddressesMeta,
    people,
    peopleMeta
});

export default connect(mapStateToProps)(MailerTagDetailModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/MailerTagDetailModal/index.jsx